// extracted by mini-css-extract-plugin
module.exports = {"Info":"Info_Info__1SEyq"};